import React, { useEffect } from "react";
import Slider from "../../../../ExternalLib/Carousel/Carousel";
import useApiRequest from "../../../../Hooks/apiReq";
import SpinnerLoader from "../../../../CommonComponets/SpinnerLoader";
const SliderBanner = () => {
  const { error, loading, recallRequest, response, sendApiRequest } =
    useApiRequest();
  const [data, setData] = React.useState([]);
  const getBannerlist = () => {
    const loggedUser = sessionStorage.getItem("loggedInUser");
    const payload = {
      AutoId: loggedUser?.AutoID,
      DeviceType: "Web",
      AppVersion: loggedUser?.AppVersion,
      LoginToken: loggedUser?.LoginToken,
    };
    sendApiRequest("POST", "/Dashboard/GetBannerList", payload, {
      onSuccess: (res) => {
        // console.log("banners", res);
        const ParsedData = res?.data?.jsonData
          ? JSON.parse(res?.data?.jsonData)
          : [];
        setData(ParsedData);
      },
    });
  };
  useEffect(() => {
    getBannerlist();
  }, []);
  return (
    <div className="col-12 col-xl-8 col-xxl-9" style={{ position: "relative" }}>
      {loading && <SpinnerLoader />}
      <Slider>
        {data?.map((item, index) => (
          <div key={index} className="card border h-100 w-100 overflow-hidden">
            <div className="card-body p-3">
              <img
                className="img-fluid"
                src={item?.BannerFile}
                alt={item?.Title}
              />
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default SliderBanner;
